import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Button } from '@progress/kendo-react-buttons';
import isPage from '../hoc/isPage';
import { AppContext } from '../context/AppContext';

class OrgGroupDeletePage extends Component {

    static propTypes = {
        reportGroupID: PropTypes.string.isRequired,
        handleCloseModal: PropTypes.func,
        handleRefreshListing: PropTypes.func
    }
    handleSubmit = () => {
        const { reportGroupID } = this.props;
        // run the delete rule endpoint
        this.props.deleteData(`/api/portal/reportGroup/${reportGroupID}/DeleteReportGroup`).then(response => {
            //debugger;
            if (response.status === 200) {

                this.props.alert("success", this.props.returnLocalizedString("m0036"), this.props.returnLocalizedString("m0233"));

                // refresh the list of report groups
                this.props.handleRefreshListing();

                // if the report group we just deleted was previously being used on the dashboard, OR the reports, OR the inventory shaping page, then let's clear it out from all these areas
                let { selectedFilterReportGroup, selectedReportReportGroup, inventoryShapingSelectedReportGroup } = this.context.state;


                let needChange = false;
                if (selectedFilterReportGroup && (selectedFilterReportGroup.reportGroupID === reportGroupID)) {
                    selectedFilterReportGroup = null;
                    needChange = true;
                }
                if (selectedReportReportGroup && (selectedReportReportGroup.reportGroupID === reportGroupID)) {
                    selectedReportReportGroup = null;
                    needChange = true;
                }
                if (inventoryShapingSelectedReportGroup && (inventoryShapingSelectedReportGroup.reportGroupID === reportGroupID)) {
                    inventoryShapingSelectedReportGroup = null;
                    needChange = true;
                }




                if (needChange) {
                    this.context.setState({
                        inventoryShapingSelectedReportGroup,
                        selectedFilterReportGroup,
                        selectedReportReportGroup
                    }, () => {
                        // close the modal
                        this.props.handleCloseModal();
                    });
                } else {
                    this.props.handleCloseModal();
                }



            }
        }).catch(error => {
            //console.log('error', error);
            this.props.alert("error", this.props.returnLocalizedString("m0023"), this.props.returnLocalizedString("m0234"));
        });
    }
    render() {

        //!DBTRANS! @m0023@ Error! !DEVNOTE! Action status
        //!DBTRANS! @m0036@ Success! !DEVNOTE! Action status
        //!DBTRANS! @m0175@ Close !DEVNOTE! Option label
        //!DBTRANS! @m0176@ Yes !DEVNOTE! Option label
        //!DBTRANS! @m0233@ The report group was successfully deleted. !DEVNOTE!
        //!DBTRANS! @m0234@ The report group could not be deleted. Please try again. !DEVNOTE!
        //!DBTRANS! @m0235@ Do you want to delete this report group? !DEVNOTE!

        return (
            <div>
                <span>
                    {this.props.returnLocalizedString("m0235")}
				</span>

                <DialogActionsBar>
                    <Button className="k-button" onClick={this.props.handleCloseModal}>{this.props.returnLocalizedString("m0175")}</Button>
                    <Button className="k-button k-primary yes" onClick={this.handleSubmit}>{this.props.returnLocalizedString("m0176")}</Button>
                </DialogActionsBar>
            </div>
        );
    }
}

export default isPage(OrgGroupDeletePage);
OrgGroupDeletePage.contextType = AppContext;


// WEBPACK FOOTER //
// ./src/containers/OrgGroupDeletePage.js